import React from "react";
import HelperStyles from 'utils/HelperStyles'
import { ThemedItemStyles } from 'styles/components/atoms/ThemedItem'
import { View } from 'react-native'
import { colorList } from 'utils/colors'
import { dataConstants } from 'services/redux/data/constants'
import _ from "lodash";
import { TimeslotIconStyles } from 'styles/components/molecules/TimeslotIcon'
import { useSelector } from 'react-redux'
import HelperTimeslot from 'utils/helper-timeslot'
import Icon from 'components/atoms/Icon'
import isEqual from 'react-fast-compare'


const errorDefaults = {
	icon: null,
	icon_color: colorList.WHITE.primary,
	background_color: colorList.RED.primary
}

const getProperty = ( identifier, propertyName, overWriteProperties = null ) => {
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );
	
	if( overWriteProperties !== null && _.get( overWriteProperties, [ propertyName ], '[empty]' ) !== '[empty]' ) { // check of '[empty]' instead of null since some values can be null as well
		return _.get( overWriteProperties, [ propertyName ]);
	}
	
	let value = _.get( _timeslotKinds, [ identifier, propertyName ], null );
	if( value !== null ) {
		return value;
	}
	
	return _.get( errorDefaults, [ propertyName ], null );
}

const TimeslotIcon = ({ timeslot, overWriteProperties = null, ...props }) => {

	// Grab each property separately to allow for overWriteProperties
	const identifier = HelperTimeslot.combineKindSubKind( timeslot );
	const icon = getProperty( identifier, 'icon', overWriteProperties );
	const subIcon = getProperty( identifier, 'sub_icon', overWriteProperties);
	const secondarySubIcon = getProperty( identifier, 'secondary_sub_icon', overWriteProperties );
	const backgroundColor = getProperty( identifier, 'background_color', overWriteProperties );
	let iconColor =  getProperty( identifier, 'icon_color', overWriteProperties );

	// Check if RGB color is dark
	if( iconColor === 'auto' ) {
		iconColor =  HelperStyles.isColorDark( backgroundColor ) ? colorList.WHITE.primary : colorList.BLACK.primary;
	}
	
	const iconProps = {
		...props,
		size: 22,
		color: iconColor
	};
	
	const subItemComponents = [];
	
	if( subIcon !== null ) {
		const subIconProps = {
			...iconProps,
			size: 9
		};
		
		iconProps.style = TimeslotIconStyles.iconWithSubIcons;
		subItemComponents.push( <Icon icon={ subIcon } {...subIconProps} /> );
	}
	
	if( secondarySubIcon !== null ){
		const secondarySubIconProps = {
			...iconProps,
			size: 9,
			style: TimeslotIconStyles.secondarySubIcon
		};
		
		iconProps.style = TimeslotIconStyles.iconWithSubIcons;
		
		subItemComponents.push( 
			<Icon 
				{...secondarySubIconProps} 
				icon={ secondarySubIcon } 
			/>
		);
	}
	
	return (
		<View 
			style={ [ ThemedItemStyles.accessoryLeft, { backgroundColor: backgroundColor } ] }>

			{ subItemComponents.length > 0 && (
				<View 
					style={ TimeslotIconStyles.subIconContainer }>

					{ subItemComponents.reverse() }
				</View>
			)}

			<Icon 
			 	{ ...iconProps } 
				icon={ icon }
			/>
		</View>
	);
};

export default React.memo( TimeslotIcon, isEqual );
